import apiConfig from '../config/apiConfig';
import { getAuth } from 'firebase/auth';

async function withIdToken(headers = {}) {
  try {
    const user = getAuth().currentUser;
    if (!user) return headers;

    const token = await user.getIdToken();
    return { ...headers, Authorization: `Bearer ${token}` };
  } catch {
    return headers;
  }
}

export async function apiFetch(path, { method = 'GET', headers = {}, body } = {}) {
  const url = path.startsWith('http')
    ? path
    : `${apiConfig.BASE_URL}${path}`;

  const finalHeaders = await withIdToken({
    'Content-Type': 'application/json',
    ...headers
  });

  const res = await fetch(url, {
    method,
    headers: finalHeaders,
    body: body ? JSON.stringify(body) : undefined
  });

  let data = null;
  try {
    data = await res.json();
  } catch {
    // Non-JSON or empty payloads are fine.
  }

  if (!res.ok) {
    const err = new Error(`api_error_${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data ?? {};
}
